import { domain } from 'modules/data';

export const placeholderList = [
    domain.SupplierEmailReplacements.poNumber,
    domain.SupplierEmailReplacements.totalAmount,
    domain.SupplierEmailReplacements.companyName,
    domain.SupplierEmailReplacements.supplierName,
];
